import React from "react";
import WhatsOnResults from "../WhatsOnHero";

import Hero from "../GernericHero";
import { tourItem } from "../WhatsOnHero/types";

interface Props {
  tourCode: string;
  tourOptions: tourItem[];
  heading: string;
  subheading?: string;
  mobileImage?: string;
  tabletImage?: string;
  desktopImage?: string;
}

const RoundUpResultsTable = ({
  heading,
  subheading,
  tourCode,
  tourOptions,
  mobileImage,
  tabletImage,
  desktopImage
}: Props) => {
  return (
    <>
      <Hero isResults desktopImage={desktopImage} tabletImage={tabletImage} mobileImage={mobileImage} heading={heading} subheading={subheading} />
      <WhatsOnResults results tourOptions={tourOptions} tourCode={tourCode} />
    </>
  );
};

export default RoundUpResultsTable;
